export default [

     {
          path: '/likelihood-impact-setting',
          name: 'LikelihoodImpactSetting',
          component: () => import("@/views/Page/LikelihoodImpactSetting/LikelihoodImpactSetting.vue"),
           meta: {
               title: 'Likelihood Impact Setting',
          },
     }
];